// The single source of the facts every legal document cites (spec 2026-09-09-02).
// The Markdown documents reference these as `{{company.<field>}}`; change a value
// here and all four documents, in both languages, follow. Empty optional fields
// make their line disappear rather than render a placeholder — an "à compléter"
// on a legal notice is worse than an omission.
export const company = {
    /** Product name as it appears to users. */
    product: 'Buildtory',
    /** Public site the product is served from. */
    website: 'https://buildtory.io',
    /** Legal entity publishing the service. */
    name: 'WEBINGENIA',
    /** Legal form (SAS, SARL, …). Empty until confirmed — omitted when empty. */
    legalForm: '',
    /** Share capital, e.g. "10 000 €". Empty until confirmed — omitted when empty. */
    shareCapital: '',
    address: '14 rue Félix Faure, 75015 Paris, France',
    /** Trade register line. SIREN 519 411 680 (SIRET 519 411 680 00043). */
    registration: 'RCS Paris 519 411 680',
    vat: '',
    director: 'Florent Clairambault',
    /** Address for legal, privacy and data-subject requests. */
    contactEmail: 'support@buildtory.io',
    /** Hosting provider of the production platform. */
    host: 'OVH SAS',
    hostAddress: '2 rue Kellermann, 59100 Roubaix, France',
    hostPhone: '+33 9 72 10 10 07',
    hostWebsite: 'https://www.ovhcloud.com',
    /** Date printed as "last updated" on every document. ISO, rendered per locale. */
    updated: '2026-09-09',
} as const

/** Derived clauses whose whole sentence disappears when the fact is unknown. */
export const derived = {
    /** ", SAS au capital de 10 000 €" — or nothing at all. */
    legalFormClause: [
        company.legalForm,
        company.shareCapital ? `au capital de ${company.shareCapital}` : '',
    ]
        .filter(Boolean)
        .join(' ')
        .replace(/^(.+)$/, ', $1'),
    /** A whole line, so an unknown VAT number leaves no dangling label. */
    vatLine: company.vat ? `Numéro de TVA intracommunautaire : ${company.vat}.` : '',
} as const

export type CompanyField = keyof typeof company
